import React from "react";


export default function ({link, content}) {
    return <a href={link} target="_blank" rel="noopener noreferrer">{content}</a>;
}